import React from "react";

const groupedLinks = {
  "1ere": [
    "https://gaming.enzo-turpin.fr",
    "https://easterquiz.enzo-turpin.fr",
    "https://groupietracker.enzo-turpin.fr",
    "https://mini-jeux.enzo-turpin.fr",
    "https://forum.enzo-turpin.fr",
  ],
  "2eme": [
    "https://cocktailrecipes.enzo-turpin.fr",
    "https://booked.enzo-turpin.fr",
    "https://enzo-turpin.fr",
  ],
};

const customLabels = {
  gaming: "Gaming",
  groupietracker: "Groupie Tracker",
  "mini-jeux": "Mini-Jeux",
  forum: "Forum",
  booked: "Booked",
  cocktailrecipes: "Cocktail Recipes",
  "enzo-turpin.fr": "Portfolio",
};

function getDnsLabel(url) {
  try {
    const { hostname } = new URL(url);
    if (hostname === "enzo-turpin.fr")
      return customLabels["enzo-turpin.fr"] || "enzo-turpin.fr";
    const sub = hostname.replace(".enzo-turpin.fr", "");
    if (customLabels[sub]) return customLabels[sub];
    return sub.charAt(0).toUpperCase() + sub.slice(1);
  } catch {
    return url;
  }
}

// Fonction pour afficher "1<sup>ère</sup>" ou "2<sup>ème</sup>"
function formatYearLabel(label) {
  if (label === "1ere") {
    return (
      <>
        1<sup>ère</sup> Année
      </>
    );
  } else if (label === "2eme") {
    return (
      <>
        2<sup>ème</sup> Année
      </>
    );
  }
  return label; // fallback
}

function App() {
  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-center p-4 bg-cover bg-center"
      style={{
        backgroundImage:
          "url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1500&q=80)",
      }}
    >
      <div className="w-full max-w-xl bg-white/60 rounded-2xl shadow-xl p-8 mt-8 mb-8 backdrop-blur-md border border-white/40">
        <h1 className="text-4xl md:text-5xl font-extrabold text-center mb-4 text-indigo-700 drop-shadow-lg">
          Sites disponibles
          <br className="hidden md:block" />
          <span className="text-lg md:text-2xl block font-semibold mt-2 text-indigo-700">
            <a
              href="https://enzo-turpin.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              enzo-turpin.fr
            </a>
          </span>
        </h1>
        <p className="text-center text-gray-700 mb-8 text-base md:text-lg">
          Retrouvez ici tous les sous-domaines actifs de mon site, accessibles
          en un clic.
        </p>

        {Object.entries(groupedLinks).map(([year, urls]) => (
          <div key={year} className="mb-6 w-full">
            <h2 className="text-2xl font-semibold text-indigo-800 mb-2">
              {formatYearLabel(year)}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
              {urls.map((url) => (
                <a
                  key={url}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full text-center font-bold py-3 px-6 rounded-2xl shadow-xl hover:scale-105 transition-all duration-200 ease-in-out text-lg md:text-xl tracking-wide border border-white/60 backdrop-blur-lg liquid-glass-btn"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(255,255,255,0.35) 60%, rgba(200,220,255,0.18) 100%)",
                    color: "#1a237e",
                    boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.18)",
                    border: "1.5px solid rgba(255,255,255,0.6)",
                    backdropFilter: "blur(16px)",
                    WebkitBackdropFilter: "blur(16px)",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <span style={{ position: "relative", zIndex: 2 }}>
                    {getDnsLabel(url)}
                  </span>
                  <span
                    style={{
                      content: "''",
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background:
                        "linear-gradient(120deg, rgba(255,255,255,0.45) 0%, rgba(255,255,255,0.05) 80%)",
                      opacity: 0.7,
                      borderRadius: "inherit",
                      pointerEvents: "none",
                      zIndex: 1,
                    }}
                  />
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default App;
